<template>
    <div>
        <rkm-modal
            extraLarge
            ref="RkmModalExames"
            title="Confirmação do agendamento de exame"
        >
            <rkm-alert show info>
                <strong>
                    {{itemSelecionado.data}} -
                    {{ getStringDiaSemana(itemSelecionado.semanaId) }}
                </strong>
            </rkm-alert>

            <Cotas
                :itemSelecionado="itemSelecionado"
                :agendamento="agendamento"
                @handleSaldo="handleSaldo"
            />

            <Form
                ref="Form"
                :paciente="paciente"
                :data="data"
                :itemSelecionado="itemSelecionado"
                :verificaAutorizacao="verificaAutorizacao"
                :agendamento="agendamento"
                :jornadas="jornadas"
                :vagas="vagas"
                :horarioAgendamento="horarioAgendamento"
                :cota="cota"
                :regulacaoSolicitacao="regulacaoSolicitacao"
                :reagendar="reagendar"
                @horariosDisponiveis="handleHorariosDisponiveis"
                @handleAgendamento="handleAgendamento"
                @handleAutoriza="handleAutoriza"
                @handleExit="handleExit"
            />

            <template v-slot:footer="{ cancel }">

                <rkm-button @click="cancel">
                    Voltar
                </rkm-button>

                <rkm-button
                    @click.stop="validate"
                    color="primary"
                >
                    Confirmar
                </rkm-button>
            </template>
        </rkm-modal>

        <ModalPermissao
            ref="RkmModalPermissao"
            @saveModal="saveModal"
            @handleExitSupervisor="handleExit"
            :origem="origem"
        />
    </div>
</template>

<script>

// Mixins.
import { error, repository } from '@/mixins'

//Components.
import Form from '@/components/exame-laboratorial/agendamento-exame/tabs/cadastro/components/exames/Form'
import Cotas from '@/components/exame-laboratorial/agendamento-exame/tabs/cadastro/components/cotas/Form'
import ModalPermissao from '@/components/exame-laboratorial/agendamento-exame/tabs/cadastro/components/permissao/Modal'

//Enums
import tipoJornada from '@/enums/exame-laboratorial/tipoJornada'
import diasSemana from '@/enums/exame-laboratorial/diasSemana'
import statusAgendamento from '@/enums/exame-laboratorial/statusAgendamento'

// Moment.
import moment from 'moment'

export default {
    components: { Form, Cotas, ModalPermissao },
    data: () => ({
        verificaAutorizacao: false,
        index: null,
        item: null,
        enums: {
            tipoJornada,
            diasSemana,
            statusAgendamento,
        },
        horarioAtendimento: null,
        itemSelecionado: [],
        cota: {},
        exames: [],
        disponivel: true,
        horariosDisponiveis: true,
        autoriza: false,
        origem: 'vagas'
    }),
    methods: {
        open(diaSelecionado, verificaAutorizacao) {

            if (verificaAutorizacao == false) {

                this.verificaAutorizacao = true
            }

            this.itemSelecionado = diaSelecionado

            this.$refs.RkmModalExames.show()
        },
        handleExit() {

            this.$refs.RkmModalExames.hide()
        },
        handleAgendamento(value, horario){

            this.exames = value
            this.agendamento.incluido = value
            this.horarioAtendimento = horario
        },
        handleHorariosDisponiveis(horarios){

            this.horariosDisponiveis = horarios
        },
        handleAutoriza(){

            this.autoriza = true
        },
        validate(){

            this.$refs.Form.validate().then(valid => {

                if (!valid) return

                if (this.exames.length == 0 && this.agendamento.incluido.length == 0) {

                    this.showAlert('É obrigatório atribuir ao menos um exame no agendamento.', 'Atenção')

                    return false
                }

                if (!this.verificaAutorizacao && !this.autoriza) {

                    if (this.agendamento.alterarAgendamento && !this.validarPrazoValidadeExames()) {

                        return false
                    }

                    if (!this.validarColetaJaRealizadaExames()) {

                        return false
                    }

                    this.handleVagas()

                    if (!this.disponivel) {

                        const confirm = async () => {

                            this.$refs.RkmModalPermissao.open()

                            return false
                        }

                        const cancel = async () => { this.handleExit }

                        const msg = `A quantidade de vaga para o horário selecionado foi atingida, para continuar é
                            necessário informar os dados do supervisor. Deseja continuar?`

                        this.showConfirmation(msg, confirm, cancel)

                        return false
                    }
                }

                this.$emit('handleSaveAgendamento', this.exames, this.itemSelecionado, this.horarioAtendimento)

                this.$refs.RkmModalExames.hide()
            })
        },
        validarPrazoValidadeExames() {

            const exames = this.exames.length > 0 ? this.exames : this.agendamento.incluido

            const statusIgnorados = [
                this.enums.statusAgendamento.FALTOU,
                this.enums.statusAgendamento.NAO_REALIZADO,
                this.enums.statusAgendamento.AGENDADO,
                this.enums.statusAgendamento.DUPLICIDADE,
                this.enums.statusAgendamento.OUTROS
            ]

            let msgExame = ''

            exames.filter(e => e.validade !== null && e.validade !== undefined && !e.permiteRepeticao).forEach(exame => {

                let msgDatasExame = ''

                this.data.model.agendamentos.filter(e => e.pacienteId == this.paciente.id &&
                    e.agendamentoId !== this.agendamento.agendamentoId)
                        .forEach(exameIncluido => {

                            const exameFind = exameIncluido.incluido.find(m => m.codigo == exame.codigo
                                && m.statusId !== this.enums.statusAgendamento.CANCELADO)

                            if (exameFind && !statusIgnorados.includes(exameFind.statusId)) {

                                const addDay = moment(exameIncluido.data).add(exame.validade, 'days').format('YYYY-MM-DD')

                                if (moment(addDay).isAfter(this.itemSelecionado.data.split("/").reverse().join("-"))) {

                                    const dataInformada = exameIncluido.data.split("-").reverse().join("/")

                                    const data = `<strong>${dataInformada}</strong> às <strong>${exameIncluido.horaInicial}</strong>`

                                    msgDatasExame = msgDatasExame ? msgDatasExame.concat(`, ${data}`) : data
                                }
                            }
                        })

                if (msgDatasExame) {

                    const msgValidade = `O paciente já possui agendamento para o exame <strong>${exame.nome}</strong>
                        dentro do prazo de validade, na(s) seguinte(s) data(s): ${msgDatasExame}`

                    msgExame = msgExame ? msgExame.concat(`<br><br>${msgValidade}`) : msgValidade
                }
            })

            if (msgExame) {

                const confirm = async () => {

                    this.$refs.RkmModalPermissao.open()

                    return false
                }

                const cancel = async () => { this.handleExit() }

                const msg = `${msgExame}.<br><br>Para continuar é necessário informar os dados do supervisor.
                    Deseja continuar?`

                this.showConfirmation(msg, confirm, cancel)

                return false
            }

            return true
        },
        validarColetaJaRealizadaExames() {

            if (!this.agendamento.agendamentoId || !this.agendamento.data) return true

            const novaData = this.itemSelecionado.data.split("/").reverse().join("-")

            if (this.agendamento.data === novaData) return true

            const statusIgnorados = [
                this.enums.statusAgendamento.FALTOU,
                this.enums.statusAgendamento.NAO_REALIZADO,
                this.enums.statusAgendamento.AGENDADO,
                this.enums.statusAgendamento.DUPLICIDADE,
                this.enums.statusAgendamento.OUTROS
            ]

            const exames = this.exames.length > 0 ? this.exames : this.agendamento.incluido

            let msgExame = ''

            exames.filter(exame => exame.validade !== null && exame.validade !== undefined
                && !exame.permiteRepeticao
                && exame.statusId
                && exame.statusId !== this.enums.statusAgendamento.CANCELADO
                && !statusIgnorados.includes(exame.statusId)
            ).forEach(exame => {

                const addDay = moment(this.agendamento.data).add(exame.validade, 'days').format('YYYY-MM-DD')

                if (moment(addDay).isAfter(novaData)) {

                    const msgColeta = `O exame <strong>${exame.nome}</strong> já existe com a coleta realizada
                        dentro do prazo de validade.`

                    msgExame = msgExame ? msgExame.concat(`<br><br>${msgColeta}`) : msgColeta
                }
            })

            if (msgExame) {

                const confirm = async () => {

                    this.$refs.RkmModalPermissao.open()

                    return false
                }

                const cancel = async () => { this.handleExit() }

                const msg = `${msgExame}.<br><br>Para continuar é necessário informar os dados do supervisor.
                    Deseja continuar?`

                this.showConfirmation(msg, confirm, cancel)

                return false
            }

            return true
        },
        handleVagas() {

            this.disponivel = true

            let agendamentos = null

            let horarioSelecionado = this.horarioAtendimento

            if (!horarioSelecionado) {

                horarioSelecionado = this.itemSelecionado.horaInicial
            }

            this.jornadas.filter(item => item.data === this.itemSelecionado.data && item.horaInicial === horarioSelecionado).map(horario => {

                let vagas = Number(horario.vagas || 0) + Number(horario.vagasApp || 0)
                let horarioInicial = horario.horaInicial
                let tempoAtendimento = horario.tempoAtendimento

                horarioInicial = moment(horarioInicial, "HH:mm")
                    .subtract(tempoAtendimento, 'minutes')
                    .format('HH:mm');

                if (horario.tipoId == this.enums.tipoJornada.DINAMICA) {

                    for (let i = 0; i < vagas; i++) {

                        if (i !== this.tabIndex) {

                            horarioInicial = moment(horarioInicial, "HH:mm")
                                .add(tempoAtendimento, 'minutes')
                                .format('HH:mm');

                            if (horarioInicial == horarioSelecionado) {

                                agendamentos = this.vagas.filter(item =>
                                    item.data === this.itemSelecionado.data
                                    && item.horaInicial == horarioSelecionado
                                    && item.agendamentoId !== this.agendamento.agendamentoId).length

                                if (agendamentos > 0) {

                                    this.disponivel = false
                                }
                            }
                        }
                    }
                } else {

                    agendamentos = this.vagas.filter(item => item.data === this.itemSelecionado.data
                        && item.horaInicial == horarioSelecionado
                        && item.agendamentoId !== this.agendamento.agendamentoId).length

                    if (agendamentos >= vagas) {

                        this.disponivel = false
                    }
                }

                return this.disponivel
            })
        },
        getStringDiaSemana(dia) {

             if(dia == this.enums.diasSemana.DOMINGO) {

               return 'DOMINGO'
            } else if (dia == this.enums.diasSemana.SEGUNDA_FEIRA) {

               return 'SEGUNDA-FEIRA'
            } else if (dia == this.enums.diasSemana.TERCA_FEIRA) {

               return 'TERÇA-FEIRA'
            } else if (dia == this.enums.diasSemana.QUARTA_FEIRA) {

               return 'QUARTA-FEIRA'
            } else if (dia == this.enums.diasSemana.QUINTA_FEIRA) {

               return 'QUINTA-FEIRA'
            } else if (dia == this.enums.diasSemana.SEXTA_FEIRA) {

               return 'SEXTA-FEIRA'
            } else if (dia == this.enums.diasSemana.SABADO) {

               return 'SÁBADO'
            }
        },
        handleSaldo(item) {

            this.cota = item

            if (this.regulacaoSolicitacao && !this.regulacaoSolicitacao.exameLaboratorialAgendamentoId) {

                this.$nextTick().then(() => this.$refs.Form.addExamesRegulados())
            }
        },
        saveModal(supervisorId){

            this.agendamento.supervisorId = supervisorId
            this.autoriza = true

            this.validate()
        },
    },
    props: {
        data: { type: Object, required: true },
        paciente: { type: Object, required: true},
        agendamento: { type: Object, required: true },
        jornadas: { type: Array, required: true },
        vagas: { type: Array, required: true },
        horarioAgendamento: { type: String, default: null },
        regulacaoSolicitacao: { type: Object },
        reagendar: { type: Object },
    },
    mixins: [ error, repository ],
}
</script>